function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import qs from 'query-string';
import { locationShape } from 'tss-core-lib-common';
import { NavLink as RNavLink } from 'react-router-dom';

var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      props = _objectWithoutProperties(_ref, ['to']);

  return React.createElement(RNavLink, Object.assign({
    to: to,
    isActive: function isActive(match, location) {
      if (match && to.search && location.search) {
        var toQ = qs.parse(to.search);
        var lQ = qs.parse(location.search);
        return toQ.tab === lQ.tab && (!toQ.datatab || toQ.datatab === lQ.datatab);
      }
      return Boolean(match);
    }
  }, props));
};

NavLink.propTypes = {
  to: locationShape.isRequired
};

export default NavLink;